import { flow, observable, makeObservable } from 'mobx';

import BaseStore from './BaseStore';
import InsuranceAPI from '../api/insurance';

class InsuranceStore extends BaseStore {
  isSent = false;
  isFailed = false;

  sendInsuranceRequest = flow(function* (payload, setErrors) {
    try {
      yield InsuranceAPI.sendInsuranceRequest(payload);
      this.isSent = true;
    } catch (errors) {
      if (errors?.response?.data?.errorMessages) {
        setErrors(errors.response.data.errorMessages);
      } else {
        console.error(errors);
        this.isFailed = true;
      }
    }
  });

  constructor() {
    super();

    makeObservable(this, {
      isSent: observable,
      isFailed: observable,
    });
  }
}

export default new InsuranceStore();
